import firebase, { DocumentSnapshot } from "store/firebase";
import "firebase/firestore";

import { answerFromDoc } from "./utils";
import { AnyAction, Dispatch } from "redux";
import { TastingAnswer } from "./reducer";
import { createSubscriptionRegistry } from "store/util/subscription-registry";

export const ANSWER_MODIFIED_EVENT = "answer-modified";
export const ACTION_ANSWERS_LISTEN_CHANGE = "answers/listen_change";

/**
 * Per-event Firestore subscription registry. Keyed by `eventId` so two events
 * can be subscribed simultaneously without one stomping the other (the
 * previous singleton implementation cancelled the previous listener every
 * time the user switched events).
 */
const subscriptions = createSubscriptionRegistry();

export function subscribe(eventId: string, answersId: string) {
  subscriptions.subscribe(eventId, () => {
    const eventDocRef = firebase.firestore().collection("events").doc(eventId);
    const itemRef = eventDocRef.collection("answers").doc(answersId);
    return itemRef.onSnapshot((snapshot: DocumentSnapshot) => {
      const answerData = answerFromDoc(snapshot, eventId);
      const windowEvent = new CustomEvent(ANSWER_MODIFIED_EVENT, {
        detail: answerData,
      });
      window.dispatchEvent(windowEvent);
    }, console.log);
  });
}

export function unsubscribe(eventId?: string) {
  if (eventId) {
    subscriptions.unsubscribe(eventId);
  } else {
    subscriptions.unsubscribeAll();
  }
}

export default function listenChange(event: TastingAnswer) {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch({ type: ACTION_ANSWERS_LISTEN_CHANGE, payload: event });
  };
}
